import React from 'react';
import { withNavList } from 'react-skeletal-nav';
import PropTypes from 'prop-types';

import './ExpandedNavList.scss';

const ExpandedNavList = ({ children }) => {
  const maxItemsPerRow = 4;
  const minItemsPerRow = 3;
  const count = Math.min(Math.max(children.length, minItemsPerRow), maxItemsPerRow);
  return (
    <ul className="expanded-nav-list" style={{ '--count': count }}>{children}</ul>
  );
};

ExpandedNavList.propTypes = {
  children: PropTypes.node.isRequired
};

export default withNavList(ExpandedNavList);
